import { useState } from "react";
import { toast } from "sonner";
import { KeyRound, CreditCard, Shield } from "lucide-react";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { useSanitarioAuth } from "../../context/SanitarioAuthContext";

export default function SanitarioImpostazioni() {
  const { activeOperatore, setPin } = useSanitarioAuth();
  const [pin, setPinValue] = useState("");
  const [pinConfirm, setPinConfirm] = useState("");
  const [badge, setBadge] = useState("");
  const [saving, setSaving] = useState(false);

  const handleSavePin = async (e) => {
    e.preventDefault();
    if (!/^\d{4,8}$/.test(pin)) {
      toast.error("Il PIN deve essere di 4–8 cifre");
      return;
    }
    if (pin !== pinConfirm) {
      toast.error("I PIN non coincidono");
      return;
    }
    setSaving(true);
    try {
      await setPin(pin, badge.trim() || undefined);
      toast.success("PIN tablet aggiornato");
      setPinValue("");
      setPinConfirm("");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Errore salvataggio PIN");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="max-w-lg mx-auto space-y-5">
      <div>
        <h1 className="text-xl font-bold text-slate-900">Impostazioni</h1>
        <p className="text-sm text-slate-500 mt-1">
          Accesso rapido dal tablet.
        </p>
      </div>

      <section className="bg-white rounded-2xl border border-slate-200 shadow-sm p-5 space-y-2">
        <div className="flex items-center gap-2 text-slate-800 font-semibold">
          <Shield className="w-4 h-4" />
          Operatore
        </div>
        <p className="text-sm text-slate-700">
          {activeOperatore?.nome} {activeOperatore?.cognome}
        </p>
        <p className="text-xs text-slate-500">{activeOperatore?.email}</p>
        <p className="text-xs text-slate-500">
          PIN: {activeOperatore?.has_pin ? "configurato" : "non configurato"}
          {" · "}
          Badge: {activeOperatore?.has_badge ? "configurato" : "non configurato"}
        </p>
      </section>

      <form
        onSubmit={handleSavePin}
        className="bg-white rounded-2xl border border-slate-200 shadow-sm p-5 space-y-4"
      >
        <div className="flex items-center gap-2 font-semibold text-slate-800">
          <KeyRound className="w-4 h-4" />
          PIN di accesso tablet
        </div>
        <p className="text-xs text-slate-500">
          Dopo il primo accesso con email e password, imposta un PIN per gli accessi rapidi
          sul dispositivo condiviso.
        </p>
        <div className="space-y-2">
          <Label>Nuovo PIN (4–8 cifre)</Label>
          <Input
            type="password"
            inputMode="numeric"
            value={pin}
            onChange={(e) => setPinValue(e.target.value.replace(/\D/g, "").slice(0, 8))}
            className="h-12 tracking-widest text-center text-lg"
            required
          />
        </div>
        <div className="space-y-2">
          <Label>Conferma PIN</Label>
          <Input
            type="password"
            inputMode="numeric"
            value={pinConfirm}
            onChange={(e) => setPinConfirm(e.target.value.replace(/\D/g, "").slice(0, 8))}
            className="h-12 tracking-widest text-center text-lg"
            required
          />
        </div>
        <div className="space-y-2">
          <Label className="flex items-center gap-1.5">
            <CreditCard className="w-3.5 h-3.5" />
            Codice badge (opzionale)
          </Label>
          <Input
            value={badge}
            onChange={(e) => setBadge(e.target.value)}
            placeholder="Es. BADGE-001"
            className="h-11"
          />
        </div>
        <Button
          type="submit"
          disabled={saving}
          className="w-full h-11 bg-[#C83048] hover:bg-[#A8283C]"
        >
          {saving ? "Salvataggio…" : "Salva PIN / badge"}
        </Button>
      </form>
    </div>
  );
}
